/**
 * Парсит сообщение об ошибке rate limit и извлекает количество секунд
 * @param errorMessage - сообщение об ошибке от сервера
 * @returns количество секунд или null, если не удалось извлечь
 */
export const parseRateLimitSeconds = (errorMessage: string): number | null => {
  const match = errorMessage.match(/через\s+(\d+)\s+сек/i);

  if (match !== null && match[1] !== undefined && match[1] !== '') {
    const seconds = parseInt(match[1], 10);
    return isNaN(seconds) ? null : seconds;
  }

  return null;
};

/**
 * Проверяет, является ли ошибка ошибкой rate limit
 * @param errorMessage - сообщение об ошибке
 * @returns true, если это ошибка rate limit
 */
export const isRateLimitError = (errorMessage: string): boolean => {
  return /запрос\s+уже\s+отправлен.*через\s+\d+\s+сек/i.test(errorMessage);
};
